import { Routes, Route } from "react-router-dom";
import { AdminAuthProvider } from "./AuthContext.js";
import { ProtectedRoute } from "./ProtectedRoute.js";
import { AdminLayout } from "./AdminLayout.js";
import { Login } from "./pages/Login.js";
import { Dashboard } from "./pages/Dashboard.js";
import { Categories } from "./pages/Categories.js";
import { EventsList } from "./pages/EventsList.js";
import { EventForm } from "./pages/EventForm.js";
import { GameConfig } from "./pages/GameConfig.js";
import { Pages } from "./pages/Pages.js";
import { ImportExport } from "./pages/ImportExport.js";

export function AdminApp() {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="karten" element={<EventsList />} />
          <Route path="karten/neu" element={<EventForm />} />
          <Route path="karten/:id" element={<EventForm />} />
          <Route path="kategorien" element={<Categories />} />
          <Route path="spiele" element={<GameConfig />} />
          <Route path="seiten" element={<Pages />} />
          <Route path="import-export" element={<ImportExport />} />
        </Route>
      </Routes>
    </AdminAuthProvider>
  );
}
